import React from "react";
import { useTaskAuthorEmail } from "../../../hooks/queries/useTaskAuthorEmail";

interface AddedByNoteProps {
  /** Undefined for a brand-new, not-yet-saved Task — nothing to show yet. */
  taskId: string | null | undefined;
  /** The Task's Author (tasks.user_id) — null means the account is gone
   * (ADR-0002). */
  authorId: string | null | undefined;
  viewerId: string | undefined;
}

/**
 * "Added by", inside an opened Task only, when somebody else wrote it
 * (CONTEXT.md's Author). Only ever true for a Task in a Shared list — that
 * is the only way to be looking at a Task you didn't author at all — so no
 * separate "is this list shared" check is needed here.
 */
const AddedByNote: React.FC<AddedByNoteProps> = ({ taskId, authorId, viewerId }) => {
  const writtenBySomeoneElse = authorId !== viewerId;
  const { data: email } = useTaskAuthorEmail(
    taskId,
    writtenBySomeoneElse && authorId !== null && !!taskId,
  );

  if (!taskId || !writtenBySomeoneElse) return null;

  return (
    <p className="text-xs text-warm-text-tertiary">
      Added by {authorId === null ? "a former member" : (email ?? "…")}
    </p>
  );
};

export default AddedByNote;
